export const addAsset = '/assets';
export const assetList = '/assets';
export const deleteAsset = '/assets/';
export const updateAsset = '/assets/';
export const addVendor = '/assets/addVendor';
export const vendors = '/assets/getVendors';
export const addRepair = '/assets/addRepair';
export const assetDetails = '/assets/';
